<!-- 召回通知单列表 -->
<template>
   <div>
      <subComponents ref="showSelectData"></subComponents>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'"
                  :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                  @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <el-form class="baseForm" id="mainInfo" label-width="100px" :model="sendDataInfo"
                              ref="sendDataInfo" size="mini" :show-message="false" :inline-message="false">
                              <el-row v-if="dataActionBox.actionType != 2">
                                 <el-form-item v-if="formOneValue.isShow == 1"
                                    v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                    :label="formOneValue.showField" :prop="formOneValue.entityField"
                                    :rules="formOneValue.isRequired == 1 ? [{ required: true, message: formOneValue.showField + '不能为空', trigger: ['blur', 'change'] }] : []">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                       v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <df-date class="form_codition"
                                       :isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"
                                       :isShowLong="false" v-if="formOneValue.fieldType == 'date'"
                                       v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                    <!-- 检索方案 -->
                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                       :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                       effect="dark" :content="sendDataInfo[formOneValue.entityField]"
                                       placement="bottom-start">
                                       <el-input clearable v-model="sendDataInfo[formOneValue.entityField]"
                                          :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                          @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                          :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2 || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0 && isTiQu)">
                                          <el-button
                                             @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                             slot="append" icon="el-icon-search"
                                             :disabled="formOneValue.isChange == 0 || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0 && isTiQu) || dataActionBox.actionType == 2">
                                          </el-button>
                                       </el-input>
                                    </el-tooltip>
                                    <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'"
                                       :disabled="formOneValue.isChange == 0"
                                       v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                       <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)"
                                          :key="matItem.key"
                                          :label="String(Number(matItem.key)) == 'NaN' ? matItem.key : matItem.value"
                                          :value="String(Number(matItem.key)) == 'NaN' ? matItem.value : matItem.key"></el-option>
                                    </el-select>
                                    <!-- 召回通知内容 -->
                                    <el-input clearable v-else-if="formOneValue.entityField == 'notice'"
                                       :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"
                                       v-model="sendDataInfo[formOneValue.entityField]"
                                       :maxlength="$store.state.inputLength" type="textarea"></el-input>
                                    <el-input class="form_codition" v-else type="text"
                                       v-model.trim="sendDataInfo[formOneValue.entityField]"
                                       :maxlength="$store.state.inputLength"
                                       :disabled="formOneValue.isChange == 0"></el-input>
                                 </el-form-item>
                                 <el-form-item label="上传附件" prop="attachFile">
                                    <el-upload class="upload-demo" :action="requesUrl + '/upload/fileupload'"
                                       :headers="token" :multiple="true" :on-success="fileUpload"
                                       :before-remove="beforeRemove" :before-upload="beforeUpload" :file-list="fileList"
                                       list-type="picture">
                                       <el-button size="small" type="primary">点击上传</el-button>
                                       <!-- <div slot="tip" class="el-upload__tip">不超过500kb</div> -->
                                    </el-upload>
                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1"
                                    v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                       v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                    <span v-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                          sendDataInfo[formOneValue.entityField] }}</a>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                       <span v-if="sendDataInfo[formOneValue.entityField]">
                                          {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                       </span>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'formatter'">
                                       {{ getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField,
                                          formOneValue.fieldType, formOneValue.formatterContent) }}
                                    </span>


                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                           <!-- 明细 -->
                           <el-form :inline="true" size="mini">
                              <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                 <el-button type="primary" size="mini" @click="addDetails('sendDataInfo')">新增
                                 </el-button>
                                 <el-button type="primary" size="mini" @click="deleteDetails()">删除</el-button>
                                 <!-- <el-button type="primary" size="mini" @click="extract(8820873997127693)">提取</el-button> -->
                              </div>
                              <el-table size="mini" ref="mxTableRef" id="mxTable" :data="sendDataInfo.detailList"
                                 :height="mxHeight" @row-dblclick="openDateilsBox" border style="width: 100%">
                                 <el-table-column label="选择操作" width="80">
                                    <template slot-scope="scope">
                                       <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                                          <i class="el-icon-thumb"></i>
                                       </el-radio>
                                    </template>
                                 </el-table-column>
                                 <el-table-column align="center" width="180" :prop="formOneValue.entityField"
                                    :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in mxForm"
                                    :key="formOneKey" v-if="formOneValue.isShow == 1">
                                    <template slot-scope="scope">
                                       <div v-if="dataActionBox.actionType != 2">
                                          <!-- 商品 -->
                                          <el-input :ref="formOneValue.entityField"
                                             v-if="formOneValue.entityField == 'bgmName' && dataActionBox.actionType != 2"
                                             v-model.number="sendDataInfo.detailList[scope.$index].bgmName"
                                             @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                             clearable>
                                             <el-button
                                                @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                                slot="append" icon="el-icon-search"></el-button>
                                          </el-input>
                                          <!-- 批次号 -->
                                          <el-input :ref="formOneValue.entityField"
                                             v-else-if="formOneValue.entityField == 'lotno' && dataActionBox.actionType != 2"
                                             v-model="sendDataInfo.detailList[scope.$index].lotno"
                                             @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                             clearable>
                                             <el-button
                                                @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                                slot="append" icon="el-icon-search"></el-button>
                                          </el-input>
                                          <el-input :ref="formOneValue.entityField"
                                             v-else-if="formOneValue.fieldType == 'search' && dataActionBox.actionType != 2"
                                             v-model.number="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                             @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                             clearable>
                                             <el-button
                                                @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                                slot="append" icon="el-icon-search"></el-button>
                                          </el-input>

                                          <span v-else-if="formOneValue.fieldType == 'date'">
                                             <span
                                                v-if="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                                                {{
                                                   $common.getLocalTime(sendDataInfo.detailList[scope.$index][formOneValue.entityField])
                                                }}
                                             </span>
                                          </span>
                                          <el-select clearable size="mini"
                                             v-else-if="formOneValue.fieldType == 'formatter'"
                                             :disabled="formOneValue.isChange == 0"
                                             v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                             placeholder="请选择">
                                             <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)"
                                                :key="matItem.key"
                                                :label="String(Number(matItem.key)) == 'NaN' ? matItem.key : matItem.value"
                                                :value="String(Number(matItem.key)) == 'NaN' ? matItem.value : matItem.key"></el-option>
                                          </el-select>
                                          <!-- <el-input v-else-if="formOneValue.isChange == 0" class="form_codition"
                                             type="text" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                             :maxlength="$store.state.inputLength"
                                             :disabled="formOneValue.isChange == 0"></el-input> -->
                                          <span v-else>{{
                                             sendDataInfo.detailList[scope.$index][formOneValue.entityField]
                                          }}</span>
                                       </div>
                                       <div v-else>
                                          <span v-if="formOneValue.fieldType == 'date'">
                                             <span
                                                v-if="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                                                {{
                                                   $common.getLocalTime(sendDataInfo.detailList[scope.$index][formOneValue.entityField])
                                                }}
                                             </span>
                                          </span>
                                          <span v-else-if="formOneValue.fieldType == 'formatter'">
                                             {{ getValue(
                                                sendDataInfo.detailList[scope.$index][formOneValue.entityField],
                                                formOneValue.entityField, formOneValue.fieldType,
                                                formOneValue.formatterContent) }}
                                          </span>
                                          <span v-else>{{
                                             sendDataInfo.detailList[scope.$index][formOneValue.entityField]
                                          }}</span>
                                       </div>
                                    </template>
                                 </el-table-column>
                              </el-table>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <div class="foot">
               <div>
                  <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary"
                     @click="showPrintPlan">打印
                  </el-button>
                  <el-button type="primary" @click="initActionBox('sendDataInfo')"
                     v-if="dataActionBox.actionType != 2">取消</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                     v-if="dataActionBox.actionType == 0">保存</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                     v-if="dataActionBox.actionType == 1">保存</el-button>
               </div>
               <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline" v-if="footForm">
                  <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                     <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                  </el-form-item>
               </el-form>
            </div>
         </div>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
         :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
            @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import NP from "number-precision";
export default {
   name: "recallRetrieveListAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         selectDataTable: false,
         sendDataInfo: {
            startDate: "", //开始日期
            dumAnnex: '',
            attachFile: [],
            totalMoney: 0, //总金额
            totalNumber: 0, //总数量
            //   totalCbmoney: 0, //总成本金额
            totalCount: 0, //总条目数
            detailList: [],
            rcnId: ''
         },
         attachFile: [],
         detaislDataInfo: {},
         selectedDataIndex: 0,
         storageRoomList: [],
         selectedDetails: [],
         selectGoodsInfo: "",
         showTabs: "",
         formDataList: [],
         DialogVisible: false,
         seTitle: "",
         seWidth: "",
         exWidth: "",
         parentSearchData: {

         },
         mxHeight: 0,
         tabForm: [],
         mxForm: [],
         footForm: [],
         isTiQu: true,
         requesUrl: "",
         token: {
            token: sessionStorage.getItem("token"),
         },
         fileList: [],
         uploadVoList: [],
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.detailList": {
         handler: function (newValue, oldValue) {
            console.log(newValue, "newValue");

            this.sendDataInfo.totalMoney = 0; // 总金额
            this.sendDataInfo.totalNumber = 0; // 总数量
            //   this.sendDataInfo.totalCbmoney = 0; // 总成本金额
            newValue.forEach((item, keys) => {
               this.sendDataInfo.totalCount = newValue.length;
            });

         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      async fileUpload(event) {
         if (event.status == 200) {
            event.result.forEach((item) => {
               console.log(item, 'item333');
               console.log(this.sendDataInfo.attachFile, 'item333');

               this.sendDataInfo.attachFile.push(item.fileUrl)
            })
         } else {
            this.$message({
               type: 'error',
               message: event.messsage
            });
         }

      },
      beforeUpload(file) {
         for (let i = 0; i < this.sendDataInfo.attachFile.length; i++) {
            const v = this.sendDataInfo.attachFile[i]
            if (v.fileName == file.name) {
               this.$message({
                  type: "error",
                  message: "请勿重复添加",
               })
               return false
            }
         }
         console.log(file, this.sendDataInfo.attachFile);
      },
      beforeRemove(file, fileList) {
         console.log(file, fileList)
         let index = 0
         for (let i = 0; i < fileList.length; i++) {
            const item = fileList[i];
            if (item == file.fileUrl) {
               index = i
               break
            }
         }
         this.sendDataInfo.attachFile.splice(index, 1)
      },
      imgur() {
         this.requesUrl = this.$store.getters.getConfig.requestUrl;
         this.imgUrl = this.$store.getters.getConfig.imgUrl;
      },
      extract(sId) {
         this.DialogVisible = true;
         this.seId = sId;
         this.seType = "extract";
         console.log(this.sendDataInfo);
         // this.seIndex
      },
      showPrintPlan() {
         // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      //新增明细
      addDetails() {
         var flag = false;
         if (this.sendDataInfo.detailList.length > 0) {
            this.sendDataInfo.detailList.forEach((item) => {
               if (item.bgmId == "") {
                  flag = true;
                  this.$nextTick(() => {
                     this.selectedDataIndex = Number(
                        this.sendDataInfo.detailList.length - 1
                     );
                     this.tableNextFocus("bgmName", this.selectedDataIndex);
                     let refsElTable = this.$refs.mxTableRef;
                     refsElTable.clearSelection();
                     refsElTable.toggleRowSelection(
                        this.sendDataInfo.detailList[
                        this.selectedDataIndex
                        ]
                     );
                  });
               }
            });
         }
         if (flag) {
            return;
         }
         this.sendDataInfo.detailList.push({});
         var index = this.sendDataInfo.detailList.length - 1;
         for (const key in this.detaislDataInfo) {
            this.$set(
               this.sendDataInfo.detailList[index],
               key,
               this.detaislDataInfo[key]
            );
         }
         this.$nextTick(() => {
            this.selectedDataIndex = Number(
               this.sendDataInfo.detailList.length - 1
            );
            // 根据表单配置决定焦点字段
            const focusField = this.mxForm.find(item => item.entityField === 'bgmName') ? 'bgmName' :
               this.mxForm.find(item => item.entityField === 'lotno') ? 'lotno' : 'bgmName';
            this.tableNextFocus(focusField, this.selectedDataIndex);
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
               this.sendDataInfo.detailList[this.selectedDataIndex]
            );
         });
      },
      // 表格切换焦点方法
      tableNextFocus(field, index) {
         this.seIndex = index;
         if (field == "keydown") {
            if (this.sendDataInfo.detailList[index + 1] != undefined) {
               this.$refs["bgmName"][index + 1].focus();
               this.selectedDataIndex = index + 1;
               this.$nextTick(() => {
                  let refsElTable = this.$refs.mxTableRef;
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.detailList[this.selectedDataIndex]
                  );
               });
               return;
            }
            this.addDetails();
            return;
         }
         // 根据字段类型选择焦点
         if (this.$refs[field] && this.$refs[field][index]) {
            this.$refs[field][index].focus();
         }
      },
      openDateilsBox(row, column, event) {

         this.editDateilsIndex = row.index;
         this.detailList = JSON.parse(JSON.stringify(row));

      },
      changeInputModel(val) {
         this.DialogVisible = false;
         if (val && (val != "" || val != undefined)) {
            if (this.seType == "bgmName") {
               //  this.sendDataInfo.detailList[this.seIndex] = val
               for (let fkey in this.sendDataInfo.detailList[
                  this.seIndex
               ]) {
                  for (let vkey in val) {
                     if (fkey == vkey) {
                        this.$set(
                           this.sendDataInfo.detailList[this.seIndex],
                           fkey,
                           val[fkey]
                        );
                     }
                  }
               }

            } else if (this.seType == "lotno") {
               // 处理批次号选择
               for (let fkey in this.sendDataInfo.detailList[
                  this.seIndex
               ]) {
                  for (let vkey in val) {
                     if (fkey == vkey) {
                        this.$set(
                           this.sendDataInfo.detailList[this.seIndex],
                           fkey,
                           val[fkey]
                        );
                     }
                  }
               }
               // 如果选择了批次号，自动跳转到数量输入
               this.tableNextFocus("movdNum", this.seIndex);
            } else if (this.seType == "extract") {
               this.sendDataInfo.detailList.push({});
               this.selectedDataIndex =
                  this.sendDataInfo.detailList.length - 1;
               for (const key in this.detaislDataInfo) {
                  this.$set(
                     this.sendDataInfo.detailList[this.selectedDataIndex],
                     key,
                     this.detaislDataInfo[key]
                  );
               }
               for (let fkey in this.sendDataInfo.detailList[
                  this.selectedDataIndex
               ]) {
                  for (let vkey in val) {
                     if (fkey == vkey) {
                        this.$set(
                           this.sendDataInfo.detailList[
                           this.selectedDataIndex
                           ],
                           fkey,
                           val[fkey]
                        );
                     }
                  }
               }
            } else {
               this.paramValue(val, true)

            }
         }
      },
      // 赋值字段
      paramValue(val, flag) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            if (!flag) {
               if (item == "stName") {
                  this.sendDataInfo.movmOutstName = val[item];
               } else if (item == "stId") {
                  this.sendDataInfo.movmOutstid = val[item];
                  this.sendDataInfo.detailList[this.seIndex].stId = val[item];
               } else if (item == "bgsId") {
                  this.sendDataInfo.detailList[this.seIndex].movdOutbgsid =
                     val[item];
               } else {
                  this.sendDataInfo.detailList[this.seIndex][item] = val[item];
               }
            } else {
               this.$set(this.sendDataInfo, item, val[item])
            }
         });
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         if (type == "salesId") {
            // 处理销售员ID搜索
            console.log("销售员ID搜索");
         } else if (type == "lotno") {
            for (const key in this.sendDataInfo.detailList[index]) {
               this.parentSearchData[key] =
                  this.sendDataInfo.detailList[index][key];
            }
         }
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField;
      },
      getSearchName(e) {
         console.log(e);
         this.seTitle = e;
      },
      getSeWidth(e) {
         console.log(e);
         this.seWidth = e + "%";
      },


      initActionBox(sendDataInfo) {
         this.$confirm("确定取消新增吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$emit("drawerCancel", 0);
               this.init();
               this.$refs.sendDataInfo.resetFields();
            })
            .catch(() => {
               // this.$message({
               //     type: 'info',
               //     message: '取消关闭'
               // });
            });
      },
      init() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }
         this.sendDataInfo.startDate = this.$moment().valueOf(); //申请日期
         this.sendDataInfo.totalCount = 0; //总条目数
         this.sendDataInfo.totalMoney = 0; // 总金额
         this.sendDataInfo.totalNumber = 0; // 总数量
         //   this.sendDataInfo.totalCbmoney = 0; // 总成本金额
         this.sendDataInfo.detailList = [];
         this.sendDataInfo.attachFile = [];
      },
      async isShowData(name, value) {
         this.sendDataInfo[name] = value;
      },

      openBox() {
         this.dataActionBox.actionType = this.actionData.cate;
         this.formDataList = this.actionData.formData;
         var oldData = this.actionData.oldData;
         this.showTabs = this.actionData.formData[0].jciName;
         this.filterMainField();
         this.init();
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";

            var dataInfo = JSON.parse(JSON.stringify(oldData));

            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key]);
            }
            this.sendDataInfo.rcnId = dataInfo.rcnId
            this.fileList = []
            if (this.sendDataInfo.attachFile != '') {
               let imgList = this.sendDataInfo.attachFile.split(',')
               this.sendDataInfo.attachFile = imgList
               imgList.forEach(item => {
                  this.fileList.push({
                     url: this.imgUrl + '/' + item,
                  })
               })
            }
         } else {
            this.dataActionBox.boxTitle = "查看信息";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key]);
            }
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight();
               } else {
                  this.mxHeight = this.$common.getHeight();
               }
            }, 16.7);
         });
      },
      sendDataAction(sendDataInfo) {
         console.log(sendDataInfo);
         this.$refs.sendDataInfo.validate((valid) => {
            if (valid) {
               if (this.sendDataInfo.detailList.length > 0) {
                  this.sub();
               } else {

                  this.$message.warning('至少添加一条明细')
                  return false;
               }
            } else {
                this.$message({
                  message: "请完善主表单必填信息",
                  type: "error",
               });
               return false;
            }
         });
      },
      async sub() {
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         sendData.attachFile = sendData.attachFile.toString()
         console.log(sendData, "sendData999");
         if (this.dataActionBox.actionType == 0) {
            var responseData = await this.$http.addNotice(sendData);
         } else {
            var responseData = await this.$http.updateNotice(sendData);
         }
         console.log(responseData, "responseData");

         if (responseData.status == 200) {
            this.init();
            this.$message.success("操作成功");
            this.$emit("drawerCancel", 1);
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      deleteDetails(index) {
         if (this.sendDataInfo.detailList.length > 0) {
            this.isTiQu = true
            this.sendDataInfo.detailList.splice(this.selectedDataIndex, 1);
            this.selectedDataIndex = 0;
         } else {
            return this.$message({
               message: "暂无可删除明细",
               type: "warning",
            });
         }
      },
      //获取状态

      getValue(val, type, fieldType, arr) {
         var str = ""
         if (type == 'bgiType' || fieldType == 'formatter') {
            if (arr) {
               JSON.parse(arr).forEach(item => {
                  if (String(Number(item.value)) != NaN && item.value == val) {
                     str = item.key
                  } else if (String(Number(item.key)) != NaN && item.key == val) {
                     str = item.value
                  }
               })
            }
         } else {
            str = val || ""
         }
         return String(str)
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = [];
         this.formDataList.forEach((item) => {
            if (item.jciType == 1) {
               mainFormList.push(item);
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
               this.mxForm.forEach((item1) => {
                  if (item1.fieldType == "number") {
                     this.$set(this.detaislDataInfo, item1.entityField, 0);
                  } else if (item1.fieldType == "search" && item1.setField) {
                     var arr = item1.setField.split(",");
                     arr.forEach((item2) => {
                        this.$set(this.detaislDataInfo, item2, "");
                     });
                  } else {
                     this.$set(this.detaislDataInfo, item1.entityField, "");
                  }
               });

            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
            }
         });
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1)
                  this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
            }
         });
         var arr = [{ entityField: "detailList" }];
         var obj = this.$common.filterMainFields(
            this.formDataList,
            arr,
            mainFormList[0]
         );
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key]);
         }
         this.$set(this.sendDataInfo, "startDate", this.$moment().valueOf());
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.imgur();
      this.$nextTick(() => {
         this.openBox();

      });
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   /* height: 500px !important; */
   overflow-y: auto;
}

#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
   margin-bottom: 0;
}
</style>